import { on } from '@ngrx/store';

import {
  ManageSurveyActions,
  ManageSurveyApiActions,
} from './manage-survey.actions';
import { ManageSurveyState } from '../survey-state.model';

export const OPERATOR_TOOLS_HANDLERS = [
  on(
    ManageSurveyActions.saveCrmId,
    (state): ManageSurveyState => ({
      ...state,
      crmIdSaving: true,
      crmIdError: null,
    }),
  ),

  on(
    ManageSurveyApiActions.saveCrmIdSuccess,
    (state): ManageSurveyState => ({
      ...state,
      crmIdSaving: false,
      crmIdError: null,
    }),
  ),

  on(
    ManageSurveyApiActions.saveCrmIdFailure,
    (state, { error }): ManageSurveyState => ({
      ...state,
      crmIdSaving: false,
      crmIdError: error,
    }),
  ),

  on(
    ManageSurveyActions.saveAsanaId,
    (state): ManageSurveyState => ({
      ...state,
      asanaIdSaving: true,
      asanaIdError: null,
    }),
  ),

  on(
    ManageSurveyApiActions.saveAsanaIdSuccess,
    (state): ManageSurveyState => ({
      ...state,
      asanaIdSaving: false,
      asanaIdError: null,
    }),
  ),

  on(
    ManageSurveyApiActions.saveAsanaIdFailure,
    (state, { error }): ManageSurveyState => ({
      ...state,
      asanaIdSaving: false,
      asanaIdError: error,
    }),
  ),

  on(
    ManageSurveyActions.saveBillingNumber,
    (state): ManageSurveyState => ({
      ...state,
      billingNumberSaving: true,
      billingNumberError: null,
    }),
  ),

  on(
    ManageSurveyApiActions.saveBillingNumberSuccess,
    (state): ManageSurveyState => ({
      ...state,
      billingNumberSaving: false,
      billingNumberError: null,
    }),
  ),

  on(
    ManageSurveyApiActions.saveBillingNumberFailure,
    (state, { error }): ManageSurveyState => ({
      ...state,
      billingNumberSaving: false,
      billingNumberError: error,
    }),
  ),

  on(
    ManageSurveyActions.saveCustomRedirectField,
    (state): ManageSurveyState => ({
      ...state,
      customRedirectFieldSaving: true,
      customRedirectFieldError: null,
    }),
  ),

  on(
    ManageSurveyApiActions.saveCustomRedirectFieldSuccess,
    (state): ManageSurveyState => ({
      ...state,
      customRedirectFieldSaving: false,
      customRedirectFieldError: null,
    }),
  ),

  on(
    ManageSurveyApiActions.saveCustomRedirectFieldFailure,
    (state, { error }): ManageSurveyState => ({
      ...state,
      customRedirectFieldSaving: false,
      customRedirectFieldError: error,
    }),
  ),
];
